import LoadingState from 'bee-loading-state'

export default LoadingState
